const presetColors = [
  // Row 1 — Text / Grays & Black/White
  ["#000000", "#434343", "#666666", "#999999", "#B7B7B7", "#CCCCCC", "#E6E6E6", "#FFFFFF"],
  
  // Row 2 — Reds / Pinks
  ["#E52B50", "#F28B82", "#F7AFAE", "#FAD2CF", "#E67C73", "#B94A48", "#D32F2F", "#B22222"],
  
  // Row 3 — Oranges & Yellows
  ["#FBBC04", "#FDD663", "#FEF9C3", "#F2A600", "#C17D11", "#FFF475", "#FFF8B6", "#FEF9C3"],

  // Row 4 — Greens & Light Greens
  ["#CCFF90", "#E6EFC6", "#D3E3B4", "#81C995", "#388E3C", "#00C853", "#66BB6A", "#2E7D32"],

  // Row 5 — Cyans / Teals
  ["#A7FFEB", "#CBF0F8", "#E0F2F1", "#4DD0E1", "#00897B", "#00B8D4", "#26C6DA", "#00695C"],

  // Row 6 — Blues
  ["#AECBFA", "#D7E3FC", "#8AB4F8", "#4285F4", "#3367D6", "#1A73E8", "#185ABC", "#0C47A1"],

  // Row 7 — Purples / Violets
  ["#D7AEFB", "#E8DAEF", "#F3E5F5", "#B39DDB", "#673AB7", "#8E24AA", "#651FFF", "#6200EA"],
];

const fontSizes = ["12px", "14px", "16px", "18px", "20px", "22px", "24px", "32px"];

const fontFamilies = [
  "Helvetica, Arial, sans-serif",
  "Georgia, 'Times New Roman', Times, serif",
  "'Courier New', Courier, monospace"
];

export {
  presetColors,
  fontFamilies,
  fontSizes
}